import { Alert } from 'app/models/dto/alert.model';
import { Document } from 'app/models/dto/document.model';

export class SubscribeToBorrowerDocuments {
	static readonly type = '[Document] SubscribeToBorrowerDocuments';
	constructor(public borrowerId: number) {}
}

export class GetBorrowerDocuments {
	static readonly type = '[Document] GetBorrowerDocuments';
	constructor(
    public borrowerId: number,
    public refresh?: boolean
  ) {}
}

export class GetViewableMimetypes {
	static readonly type = '[Document] GetViewableMimetypes';
	constructor() {}
}

export class GetDocumentCategories {
	static readonly type = '[Document] GetDocumentCategories';
	constructor() {}
}


export class UploadDocument {
	static readonly type = 'Upload';
	constructor(
    public file: File,
    public borrowerId: number,
	public callbackFn?: (document: Document) => void,
	public errorCallbackFn?: (message) => void
  ) {}
}
export class UpdateDocumentAlert {
	static readonly type = '[Document] Update Alert';
	constructor(
		public alert: Alert | null,
	) {}
}

export class DeleteDocument {
	static readonly type = '[Document] Delete';
	constructor(public documentId: number) {}
}

export class UpdateDocument {
	static readonly type = '[Document] Update';
	constructor(public document: Document) {}
}

export class UpdateDocumentDrsVerification {
	static readonly type = '[Document] UpdateDocumentDrsVerification';
	constructor(public document: Document) {}
}

export class ClearDocumentStore {
	static readonly type = '[Document] ClearDocumentStore';
    constructor(public borrowerId: number) {}
}

export class RunExperianCommercial {
	static readonly type = '[Document] RunExperianCommercial';
	constructor(public borrowerId: number){}
}

export class PushToFlashSpread {
  static readonly type = '[Document] PushToFlashSpread';
  constructor(
    public documentId: number,
  ) {}
}

export class SetDocumentContact {
  static readonly type = '[Document] SetDocumentContact';
  constructor(
    public documentId: number,
    public contactId: number,
  ) {}
}
